export default __webpack_public_path__ + "static/media/mobile_search_black.0949bf01.svg";